export default __webpack_public_path__ + "static/media/goal-calls.79409eff.svg";